export enum RiskMonitoringObservationChipsValues {
    Actions = 1,
    Risk = 2,
}

export enum RiskMonitoringActionChipsValues {
    Observation = 1,
    Risk = 2,
}
